/**
 * @generated SignedSource<<f215f9f8d954bfcda0c2e337280a7923>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type entityLink$data = {
  readonly __typename: string;
  readonly application: {
    readonly entityId: string;
  } | null | undefined;
  readonly entityId: string;
  readonly entityUuid: string;
  readonly fullSectionPath?: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly parentSection?: string | null | undefined;
  readonly urlAlias: string;
  readonly urlRedirect: {
    readonly toUrl: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarVariantBase" | "helpersApplicationBase" | "helpersCheckIsPlusArticle" | "helpersStyleSectionContent">;
  readonly " $fragmentType": "entityLink";
};
export type entityLink$key = {
  readonly " $data"?: entityLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v3 = [
  (v0/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Section",
  "kind": "LinkedField",
  "name": "fullSectionPath",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersCheckIsPlusPage",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/)
      ],
      "type": "Page",
      "abstractKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v7 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v4/*: any*/)
    ],
    "type": "Section",
    "abstractKey": null
  }
],
v8 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersStyleSectionContent",
  "selections": (v7/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "entityLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UrlRedirect",
      "kind": "LinkedField",
      "name": "urlRedirect",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Application",
      "kind": "LinkedField",
      "name": "application",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parentSection",
          "storageKey": null
        }
      ],
      "type": "Section",
      "abstractKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersAppBarVariantBase",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckIsLiveArticle",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "flattenTypeIds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LiveArticle",
                  "kind": "LinkedField",
                  "name": "liveArticle",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Article",
              "abstractKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        (v5/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckIsPostMagazineArticle",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SectionSegmentV2",
                  "kind": "LinkedField",
                  "name": "sectionsV2",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "value",
                      "plural": true,
                      "selections": [
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckIsStyleArticle",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SectionSegmentV2",
                  "kind": "LinkedField",
                  "name": "sectionsV2",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "value",
                      "plural": true,
                      "selections": [
                        (v6/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v3/*: any*/),
                          "type": "VideoSection",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersSectionContent",
          "selections": (v7/*: any*/),
          "args": null,
          "argumentDefinitions": []
        },
        (v8/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersApplicationBase",
      "selections": [
        (v5/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPlusArticle",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PaywallType",
                  "kind": "LinkedField",
                  "name": "paywallTypes",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "Article",
              "abstractKey": null
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v8/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
};
})();

(node as any).hash = "2a0851b93cf1f88e0cc01e0f7c124f30";

export default node;
